{
  "version": 1,
  "asset_id": "180ba985-f125-40fd-9791-eeb7cdfcab63",
  "project_id": "8cc9b1c1-0457-40cd-aa82-ea9e6032ce50",
  "url": "/__l5e/assets-v1/180ba985-f125-40fd-9791-eeb7cdfcab63/venue-darts-action.webp",
  "r2_key": "a/v1/8cc9b1c1-0457-40cd-aa82-ea9e6032ce50/180ba985-f125-40fd-9791-eeb7cdfcab63/venue-darts-action.webp",
  "original_filename": "venue-darts-action.webp",
  "size": 187598,
  "content_type": "image/webp",
  "created_at": "2026-07-04T16:13:16Z"
}
